import '../../../../src/assets/stylus/ui/_dataGrid.scss'

import { h } from 'vue'
import { VDataTable, VIcon } from 'vuetify/components'
import { getObjectValueByPath } from 'vuetify/lib/util/helpers'
import Sortable from "sortablejs"

import { SafeIdMixin } from '../../mixins/safeid.mixin'

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

export default {
  name: 'j-data-grid',
  mixins: [SafeIdMixin],
  components: {
    VDataTable, VIcon
  },
  props: {
    draggable: Boolean,
    headers: { type: Array, default: () => [] },
    headersLength: { type: Number },
    headerText: { type: String, default: 'title' },
    headerKey: { type: String, default: null },
    hideHeaders: { type: Boolean, default: false },
    hideDefaultHeader: { Boolean, default: false },
    hideDefaultFooter: { type: Boolean, default: true },
    items: { type: Array, default: () => [] },
    itemKey: { type: String, default: 'sn' },
    pagination: {
      type: Object,
      default: function _default() {
        return {
          descending: false,
          page: 1,
          rowsPerPage: -1 /* -1 for All */,
          sortBy: null,
          totalItems: 0
        }
      }
    },
    search: null,
    icon: { type: Boolean, default: false },
    chart: { type: Boolean, default: false },
    sortIcon: { type: String, default: 'mdi-chevron-up' },
    modelValue: { type: Array, default: () => []  },
    sortBy: { type: Array, default: () => [{ key: 'no', order: 'asc' }] },
  },
  data: () => ({
    defaultPagination: {
      descending: false,
      page: 1,
      rowsPerPage: -1 /* -1 for All */,
      sortBy: null,
      totalItems: 0
    },
  }),
  computed: {
    dragHandlerExist() {
      return this.headers.find(h => h.type == 'drag')
    },
    computedPagination () {
      return this.hasPagination ? this.pagination : this.defaultPagination
    },
    hasPagination () {
      const pagination = this.pagination || {}
      return Object.keys(pagination).length > 0
    },
  },
  created() {
    this.localId = 'j-data-grid__' + this.safeId('')
    this.pagination.sortBy = this.itemKey
  },
  mounted() {
    if(this.draggable) this.initDraggable(this.localId, this.onRowMoved)
  },
  render () {    

    return h(VDataTable, {
      id: this.localId,
      class: {
        'v-datatable': true,
        'j_datagrid': true,
        icon: this.icon,
        chart: this.chart
      },
      // modelValue: this.value, 
      'onUpdate:modelValue': (value) => this.$emit('update:modelValue', value), 
      'onUpdate:options': (e) => this.updatePagination(e),
      sortBy: this.sortBy,
      'onUpdate:sortBy': value => this.$emit('update:sortBy', value),
      itemsPerPage: -1,  // 모든 항목 표시
      items: this.items,
      itemValue: this.itemKey, 
      hideDefaultFooter: this.hideDefaultFooter,
      // customFilter: this.customFilter,
      // customKeySort: this.customSort,
      headers: this.headers, 
      search: this.search
    }, {      
      headers: () => this.genHeader(),
      item: (props) => this.$slots.item ? this.$slots.item(props) : this.defaultItemSlot(props)
    })
  },
  methods: {
    initDraggable(id, callback) {
      this.$nextTick(() => {
        let table = document.querySelector(`#${id} table tbody`)
        if (table) {
          Sortable.create(table, {
            handle: '.handle',
            onEnd: ({ newIndex, oldIndex }) => {
              callback({ newIndex, oldIndex })
            }
          })
        }
      })
    },
    defaultItemSlot(slotProps) {
      const { item } = slotProps
      return h(
        'tr', 
        { class: { 'selected': item.selected }, onClick: () => this.propStatus(item)}, 
        [ // 드래그 핸들러 셀
          h ('td', { class: 'handle text-center' }, [ h('button', { class: 'jcon_order' }) ]),
          // No 셀
          h('td', { class: 'text-center' }, item.no),
          // Code 셀
          h('td', null, item.code),
          // Name 셀 
          h('td', null, item.name),
          // Description 셀
          h('td', null, item.desc)
        ]
      )
    },
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.sortBy = column
        this.pagination.descending = false
      }
      const sortby_ = [{ key: this.pagination.sortBy, order: this.pagination.descending ? 'desc' : 'asc' }]
      this.$emit('update:sortBy', sortby_);

      const sorted_ = this.customSort(this.items, sortby_)
      this.$emit('sorted', sorted_)
    },
    
    // customFilter (items, search, filter, headers) {
    customFilter (value, search, item ) {
      search = search.toString().toLowerCase()

      if (search.trim() === '') return true

      const props = this.headers.map(h => h.value)

      return props.some(prop => {
        return filter(getObjectValueByPath(item, prop, item[prop]), search)
      })
    },
    
    customSort (items, sortBy) {
      // 정렬 조건이 없으면 원본 배열 반환
      if (!sortBy.length) return items
      // sortBy[0] { key: 'id', order: 'asc' } 
      const { key, order } = sortBy[0]
      const descending = order === 'desc'

      const sorted = items.sort((a, b) => {
        let sortA = getObjectValueByPath(a, key)
        let sortB = getObjectValueByPath(b, key)

        if (descending) {
          [sortA, sortB] = [sortB, sortA]
        }

        // 숫자 비교
        if (!isNaN(sortA) && !isNaN(sortB)) {
          return sortA - sortB
        }

        // 문자열 비교 (소문자로 변환)
        sortA = (sortA || '').toString().toLocaleLowerCase()
        sortB = (sortB || '').toString().toLocaleLowerCase()

        if (sortA > sortB) return 1
        if (sortA < sortB) return -1
        return 0
      })

      // 정렬 후 추가 작업이 필요하면 이벤트를 emit 합니다.
      return sorted
    },
    genHeader () {
      if (this.hideDefaultHeader) return // Exit Early since no headers are needed.
      var row = []
      
      this.headers.forEach((header, i) => {
        if(this.search && header.type == 'drag') return

        const [props, children] = this.genHeaderData(
          header,
          [header[this.headerText]],
          this.headerKey ? header[this.headerKey] : i
        )
        row.push(h('th', props, children))
      })
      return this.genTR(row)
    },
    genHeaderData (header, children, key) {
      const classes = ['column']
      let data = {
        key,
        role: 'columnheader',
        scope: 'col',
        width: header.width || null,
        'aria-label': String(header[this.headerText] || ''),
        'aria-sort': 'none',
        style: {
          ...(header.color && { color: header.color }),
          ...(header.bg && { backgroundColor: header.bg }),
          ...(header.width && { width: (typeof header.width === 'number' ? `${header.width}px` : header.width) })
        }
      }
      if(this.draggable) {
        if((this.dragHandlerExist && header.type == 'drag') || 
          (!this.dragHandlerExist && header.type == 'conf')) 
            children = [h('button', { class: 'jcon_config' })]
      } else {
        if(header.type == 'conf') 
          children = [h('button', { class: 'jcon_config' })]
      }

      if (!this.draggable && (header.sortable == null || header.sortable)) {
        this.genHeaderSortingData(header, children, data, classes)
      } else {
        data['aria-label'] += ': Not sorted.' // TODO: Localization
      }

      classes.push(`text-${header.align || 'left'}`)
      if (Array.isArray(header.class)) {
        classes.push(...header.class)
      } else if (header.class) {
        classes.push(header.class)
      }
      data.class = classes

      return [data, children]
    },
    genHeaderSortingData (header, children, data, classes) {
      if (!('value' in header)) {
        console.warn('Headers must have a value property that corresponds to a value in the v-model array', this)
      }

      // data.attrs = data.attrs || {}
      data.tabIndex = 0
      data.onClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.changeSort(header.value);
      };

      classes.push('sortable')
      
      const icon = h(VIcon, { size: 'small' }, () => this.sortIcon)

      if (!header.align || header.align === 'left') {
        children.push(icon)
      } else {
        children.unshift(icon)
      }

      const pagination = this.computedPagination
      const beingSorted = pagination.sortBy === header.value
      if (beingSorted) {
        classes.push('active')
        if (pagination.descending) {
          classes.push('desc')
          data['aria-sort'] = 'descending'
          data['aria-label'] += ': Sorted descending. Activate to remove sorting.' // TODO: Localization
        } else {
          classes.push('asc')
          data['aria-sort'] = 'ascending'
          data['aria-label'] += ': Sorted ascending. Activate to sort descending.' // TODO: Localization
        }
      } else {
        data['aria-label'] += ': Not sorted. Activate to sort ascending.' // TODO: Localization
      }
    },
    genTR (children, data = {}) {
      return h('tr', data, children)
    },
    onRowMoved(val) {
      this.$emit('row-move-to', val)
    },
    updatePagination (val) {
      var pagination = this.hasPagination ? this.pagination : this.defaultPagination;
      var updatedPagination = Object.assign({}, pagination, val);
      
      // Vuetify 3 호환성: itemsPerPage를 rowsPerPage로 변환
      if (val.itemsPerPage !== undefined) {
        updatedPagination.rowsPerPage = val.itemsPerPage;
      }
      
      this.$emit('update:pagination', updatedPagination);
      if (!this.hasPagination) {
        this.defaultPagination = updatedPagination;
      }
    },
  },
}